<div class="bg-transparent pos-absolute" [style]="_blockStyle">
  <textarea
    class="bg-transparent"
    *ngIf="_commentType === 1"
    [rows]="_rows"
    [cols]="_cols"
    [attr.maxLength]="_maxLength"
    style="resize: none; font-size: 0.6cm;"
    [ngStyle]="_canvasStyle"
    #noteText
  >
  </textarea>
  <canvas
    *ngIf="_commentType === 2"
    #noteCanvas
    style="border: 2px dashed grey"
    [ngStyle]="_canvasStyle"
  ></canvas>
</div>
<div *ngIf="_commentType === 2" class="pos-absolute" [style]="_cleanBtnStyle">
  <button (click)="clearClick()">Leeren</button>
</div>

<div class="bg-transparent pos-absolute" [style]="_switchStyle">
  <div
    style="padding: 4px"
    [ngClass]="{ 'green-round-icon-border': _commentType === 1 }"
  >
    <button mat-icon-button (click)="changeCommentType(1)">
      <mat-icon style="width: 1cm; height: 1cm">keyboard</mat-icon>
    </button>
  </div>

  <div style="width: 0.5cm; height: 0.5cm"></div>
  <div
    style="padding: 0.1cm"
    [ngClass]="{ 'green-round-icon-border': _commentType === 2 }"
  >
    <button mat-icon-button (click)="changeCommentType(2)">
      <mat-icon style="width: 1cm; height: 1cm">edit</mat-icon>
    </button>
  </div>
</div>
